/*
 * heymindful Freebie-Rotation
 * Konfiguration kommt aus sections/hm-freebie-rotation.liquid (#hm-freebie-config).
 * Hängt sich an die Broadcast-Events: theme:cart:change (nach jedem Drawer-Update)
 * und stößt mit theme:cart:refresh ein Neuladen des Drawers an.
 */
(function () {
  'use strict';

  var configEl = document.getElementById('hm-freebie-config');
  if (!configEl) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    console.warn('[hm-gift] Konfiguration fehlerhaft', e);
    return;
  }
  if (!config.gifts || !config.gifts.length) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var GIFT_PROP = '_hm_gift';

  // --- Speicher (sessionStorage kann in privaten Fenstern fehlen) ---------------------------
  function getFlag(key) {
    try { return window.sessionStorage.getItem(key); } catch (e) { return null; }
  }
  function setFlag(key, value) {
    try { window.sessionStorage.setItem(key, value); } catch (e) {}
  }
  function clearFlag(key) {
    try { window.sessionStorage.removeItem(key); } catch (e) {}
  }

  // --- Testmodus: nur in Theme-Vorschau und Theme-Editor, im veröffentlichten Theme nie --------
  // Testdatum aus der Section-Einstellung oder per ?hm_gift_date=2026-11-10 (?hm_gift_date=off beendet)
  var theme = (window.Shopify && window.Shopify.theme) || {};
  var isPreview = !!((window.Shopify && window.Shopify.designMode) || (theme.role && theme.role !== 'main'));
  var testDate = null;
  if (isPreview) {
    var params = new URLSearchParams(window.location.search);
    if (params.has('hm_gift_date')) {
      if (params.get('hm_gift_date') === 'off') clearFlag('hm_gift_date');
      else setFlag('hm_gift_date', params.get('hm_gift_date'));
    }
    testDate = getFlag('hm_gift_date') || config.testDate || null;
    if (testDate) console.info('[hm-gift] Testmodus aktiv, simuliertes Datum:', testDate);
  }

  // --- Datum: "01.11.2026 09:00" oder "2026-11-01 09:00" (lokale Zeit) -----------------------
  function parseDate(str, fallbackHour) {
    if (!str) return null;
    str = String(str).trim();
    var m = str.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})(?:[ T,]+(\d{1,2}):(\d{2}))?$/);
    var y, mo, d, h, mi;
    if (m) {
      d = +m[1]; mo = +m[2]; y = +m[3]; h = m[4]; mi = m[5];
    } else {
      m = str.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T]+(\d{1,2}):(\d{2}))?$/);
      if (!m) return null;
      y = +m[1]; mo = +m[2]; d = +m[3]; h = m[4]; mi = m[5];
    }
    if (h === undefined) {
      h = fallbackHour;
      mi = 0;
    }
    return new Date(y, mo - 1, d, +h, +mi, 0);
  }

  function now() {
    return (testDate && parseDate(testDate, 12)) || new Date();
  }

  function activeGift() {
    var t = now().getTime();
    for (var i = 0; i < config.gifts.length; i++) {
      var gift = config.gifts[i];
      var start = parseDate(gift.start, 0);
      var end = parseDate(gift.end, 23);
      if (end && end.getMinutes() === 0 && !/:\d{2}$/.test(gift.end)) end.setMinutes(59, 59);
      if (start && end && t >= start.getTime() && t <= end.getTime()) return gift;
    }
    return null;
  }

  // --- Warenkorb-API --------------------------------------------------------------------------
  function request(path, body) {
    return fetch(root + path, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (response) {
      return response.json().then(function (json) {
        if (!response.ok) {
          var error = new Error(json.description || json.message || 'Cart error');
          error.status = response.status;
          throw error;
        }
        return json;
      });
    });
  }

  function isGiftLine(item) {
    return !!(item.properties && item.properties[GIFT_PROP]);
  }

  function setLineQuantity(line, quantity) {
    return request('cart/change.js', { id: line.key, quantity: quantity });
  }

  function addGift(gift) {
    var properties = {};
    properties[GIFT_PROP] = '1';
    if (config.text.property) properties[config.text.property] = 'Ja';
    return request('cart/add.js', { items: [{ id: gift.variant, quantity: 1, properties: properties }] });
  }

  function refreshDrawer() {
    document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
    if (!document.querySelector('cart-items')) window.location.reload();
  }

  // --- Hinweis im Warenkorb ------------------------------------------------------------------
  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatMoney(cents) {
    var amount = cents / 100;
    try {
      return new Intl.NumberFormat(config.locale || 'de', {
        style: 'currency',
        currency: config.currency || 'EUR',
        minimumFractionDigits: amount % 1 === 0 ? 0 : 2
      }).format(amount);
    } catch (e) {
      return amount.toFixed(2).replace('.', ',') + ' €';
    }
  }

  function fillText(template, gift, remaining) {
    return escapeHtml(template || '')
      .replace(/\[geschenk\]/g, '<strong>' + escapeHtml(gift.title) + '</strong>')
      .replace(/\[betrag\]/g, '<strong>' + escapeHtml(formatMoney(remaining)) + '</strong>');
  }

  function mountBanners() {
    var anchors = document.querySelectorAll('[data-free-shipping]');
    if (!anchors.length) anchors = document.querySelectorAll('[data-items-holder]');
    anchors.forEach(function (anchor) {
      if (anchor.hasAttribute('data-hm-gift-anchor')) return;
      anchor.setAttribute('data-hm-gift-anchor', '');
      var banner = document.createElement('div');
      banner.className = 'hm-gift';
      banner.hidden = true;
      banner.setAttribute('aria-live', 'polite');
      if (anchor.hasAttribute('data-free-shipping')) anchor.insertAdjacentElement('afterend', banner);
      else anchor.insertAdjacentElement('beforebegin', banner);
    });
    return document.querySelectorAll('.hm-gift');
  }

  function render(state) {
    var banners = mountBanners();
    banners.forEach(function (banner) {
      if (!state) {
        banner.hidden = true;
        return;
      }
      var gift = state.gift;
      var html = '';
      if (gift.image) html += '<img class="hm-gift__img" src="' + escapeHtml(gift.image) + '" alt="" loading="lazy" width="44" height="44">';
      html += '<div class="hm-gift__body">';
      if (state.mode === 'success') {
        html += fillText(config.text.success, gift, 0);
      } else if (state.mode === 'declined') {
        html += fillText(config.text.declined, gift, 0);
        html += ' <button type="button" class="hm-gift__readd" data-hm-gift-readd>' + escapeHtml(config.text.readd || 'Doch dazulegen') + '</button>';
      } else {
        var percent = Math.max(0, Math.min(100, Math.round((state.subtotal / gift.threshold) * 100)));
        html += fillText(config.text.progress, gift, gift.threshold - state.subtotal);
        html += '<span class="hm-gift__bar"><span style="width:' + percent + '%"></span></span>';
      }
      if (testDate) html += '<span class="hm-gift__test">Testmodus: ' + escapeHtml(testDate) + ' (Geschenk kostet ohne Rabatt den Normalpreis)</span>';
      html += '</div>';
      banner.innerHTML = html;
      banner.hidden = false;
    });
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-hm-gift-readd]')) return;
    var gift = activeGift();
    if (gift) clearFlag('hm_gift_declined_' + gift.variant);
    check();
  });

  // --- Kernlogik -----------------------------------------------------------------------------
  var busy = false;
  var pending = false;

  function check() {
    if (busy) {
      pending = true;
      return;
    }
    busy = true;
    run()
      .catch(function (error) {
        console.warn('[hm-gift]', error);
      })
      .then(function () {
        busy = false;
        if (pending) {
          pending = false;
          check();
        }
      });
  }

  function run() {
    return request('cart.js').then(function (cart) {
      var gift = activeGift();
      var giftLines = cart.items.filter(isGiftLine);
      // Gutscheine zählen nicht zum Mindestbestellwert (wie in der "Kaufe X"-Kollektion des Rabatts)
      var subtotal = cart.items.reduce(function (sum, item) {
        return isGiftLine(item) || item.gift_card ? sum : sum + item.final_line_price;
      }, 0);
      var tasks = [];

      // Geschenke aus anderen Wochen (oder ohne aktive Aktion) entfernen
      giftLines.forEach(function (line) {
        if (!gift || line.variant_id !== gift.variant) tasks.push(remove(line));
      });

      if (!gift) return finish(tasks, null);

      var addedKey = 'hm_gift_added_' + gift.variant;
      var declinedKey = 'hm_gift_declined_' + gift.variant;
      var blockedKey = 'hm_gift_blocked_' + gift.variant;
      var own = giftLines.filter(function (line) { return line.variant_id === gift.variant; });
      var qualifies = subtotal > 0 && subtotal >= gift.threshold;

      if (getFlag(blockedKey)) {
        own.forEach(function (line) { tasks.push(remove(line)); });
        return finish(tasks, null);
      }

      if (own.length) {
        if (!qualifies) {
          own.forEach(function (line) { tasks.push(remove(line)); });
          clearFlag(addedKey);
          return finish(tasks, { gift: gift, mode: 'progress', subtotal: subtotal });
        }
        // Sicherung: ohne aktiven Shopify-Rabatt wäre das Geschenk kostenpflichtig
        if (!testDate && own[0].final_line_price > 0) {
          console.warn('[hm-gift] Kein aktiver Rabatt für', gift.title, '- Geschenk wird entfernt.');
          setFlag(blockedKey, '1');
          own.forEach(function (line) { tasks.push(remove(line)); });
          return finish(tasks, null);
        }
        // genau 1 Stück
        own.slice(1).forEach(function (line) { tasks.push(remove(line)); });
        if (own[0].quantity > 1) tasks.push({ key: own[0].key, quantity: 1 });
        return finish(tasks, { gift: gift, mode: 'success', subtotal: subtotal });
      }

      if (cart.item_count === 0) {
        clearFlag(addedKey);
        return finish(tasks, null);
      }

      if (qualifies && getFlag(addedKey)) {
        // Kundin hat das Geschenk selbst entfernt: nicht erneut hinzufügen
        clearFlag(addedKey);
        setFlag(declinedKey, '1');
      }

      if (qualifies && getFlag(declinedKey)) {
        return finish(tasks, { gift: gift, mode: 'declined', subtotal: subtotal });
      }

      if (qualifies) {
        return removeLines(tasks)
          .then(function () { return addGift(gift); })
          .then(function () {
            setFlag(addedKey, '1');
            return request('cart.js');
          })
          .then(function (updated) {
            var line = updated.items.filter(function (item) {
              return isGiftLine(item) && item.variant_id === gift.variant;
            })[0];
            if (line && !testDate && line.final_line_price > 0) {
              console.warn('[hm-gift] Kein aktiver Rabatt für', gift.title, '- Geschenk wird entfernt.');
              setFlag(blockedKey, '1');
              clearFlag(addedKey);
              return setLineQuantity(line, 0).then(function () {
                render(null);
                refreshDrawer();
              });
            }
            render({ gift: gift, mode: 'success', subtotal: subtotal });
            refreshDrawer();
          })
          .catch(function (error) {
            if (error.status === 422) setFlag(blockedKey, '1');
            throw error;
          });
      }

      return finish(tasks, { gift: gift, mode: 'progress', subtotal: subtotal });
    });
  }

  function remove(line) {
    return { key: line.key, quantity: 0 };
  }

  function removeLines(tasks) {
    return tasks.reduce(function (chain, line) {
      return chain.then(function () {
        return setLineQuantity(line, line.quantity);
      });
    }, Promise.resolve());
  }

  function finish(tasks, state) {
    render(state);
    if (!tasks.length) return Promise.resolve();
    return removeLines(tasks).then(refreshDrawer);
  }

  document.addEventListener('theme:cart:change', check);
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) check();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check);
  else check();
})();
